import { render, staticRenderFns } from "./setMealAgentAllocation.vue?vue&type=template&id=5baaf54f&"
import script from "./setMealAgentAllocation.vue?vue&type=script&lang=js&"
export * from "./setMealAgentAllocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports